import React from "react";
import { FiExternalLink } from "react-icons/fi";

export default function PoweredBy() {
  return (
    <div className="powered-by-footer" style={{ borderTop: "1px solid #f0f0f0", marginTop: 24 }}>
      <a
        href="https://pic-loud.com"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 6,
          padding: "14px 16px",
          textDecoration: "none",
          color: "#c8c8c8",
          transition: "color 0.2s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.color = "#9ca3af")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "#c8c8c8")}
      >
        <span style={{ fontSize: 9, letterSpacing: "1.8px", textTransform: "uppercase", fontWeight: 500 }}>
          Powered by
        </span>
        <span style={{ fontSize: 10, letterSpacing: "1px", fontWeight: 700, textTransform: "uppercase" }}>
          Pic-Loud
        </span>
        <FiExternalLink size={8} />
      </a>
    </div>
  );
}
